import { render, staticRenderFns } from "./EbookCardRender.vue?vue&type=template&id=0300035d&"
import script from "./EbookCardRender.vue?vue&type=script&lang=js&"
export * from "./EbookCardRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports